import { render, staticRenderFns } from "./travel-document-info.vue?vue&type=template&id=5e4ec29c&scoped=true&"
import script from "./travel-document-info.vue?vue&type=script&lang=js&"
export * from "./travel-document-info.vue?vue&type=script&lang=js&"
import style0 from "./travel-document-info.vue?vue&type=style&index=0&id=5e4ec29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4ec29c",
  null
  
)

export default component.exports